/*
 * jQuery simple slide-show plugin 1.0.0 (2023.04.01)
 *
 * Copyright (c) 2012 Andria Klimov
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */
(function($) {

  $.fn.slideshow = function(options) {

    // default configuration properties
    var config = {
      prefix        : 'slideshow',
      animation     : 'fade',
      play          : true,
      continuous    : true,
      reverse       : false,
      queue         : true,
      index         : 0,
      pauseTime     : 2000,
      switchTime    : 500,
      easing        : 'swing',
      callback      : null
    };

    // update configuration properties
    if (options)
      $.extend(config, options);

    return this.each(function() {

      // slideshow
      function Slideshow(instance) {

        var slideshow = this;

        // slide-objects
        var current = false;
        var replace = false;
        var inqueue = false;

        // play / stop
        var play = false;

        // timeout identificator
        var timeout = false;

        // animation helper
        var helper = {value: 0, rAQID: null};

        // animation types
        var animations = {
          custom: {
            init: function(instance, current) {
              helper.rAQID = window.requestAnimationFrame(function() {
                helper.rAQID = window.requestAnimationFrame(function() {
                  $(instance).children()
                    .attr('data-' + config.prefix + '-type', 'none-none');
                  $(current)
                    .attr('data-' + config.prefix + '-type', 'init-init');
                });
              });
            },
            reset: function(instance) {
              if (helper.rAQID) {
                window.cancelAnimationFrame(helper.rAQID);
                helper.rAQID = null;
              }
              $(helper).stop(true,true);
              $(instance).children()
                .attr('data-' + config.prefix + '-type', null);
            },
            animate: function(instance, current, replace, callback, action) {
              var dir = (action == 'next') ? true : (action == 'prev') ? false : ($(replace).index() - $(current).index() > 0) ? true : false;
              helper.value = 0;
              helper.rAQID = window.requestAnimationFrame(function() {
                helper.rAQID = window.requestAnimationFrame(function() {
                  $(helper).stop(true,true).animate({value: 1}, {
                    duration: config.switchTime,
                    easing: config.easing,
                    start: function() {
                      $(current)
                        .attr('data-' + config.prefix + '-type', dir ? 'hide-fore' : 'hide-back');
                      $(replace)
                        .attr('data-' + config.prefix + '-type', dir ? 'show-fore' : 'show-back');
                      $(instance).children().not([current, replace])
                        .attr('data-' + config.prefix + '-type', 'none-none');
                    },
                    complete: function() {
                      $(current)
                        .attr('data-' + config.prefix + '-type', 'none-none');
                      callback();
                    }
                  });
                });
              });
            }
          },
          fade: {
            init: function(instance, current) {
              $(instance).children().css({zIndex: 0, opacity: 1});
              $(current).css({zIndex: 1});
            },
            reset: function(instance) {
              $(instance).children().stop().css({zIndex: '', opacity: ''});
            },
            animate: function(instance, current, replace, callback, action) {
              $(replace).css({zIndex: 2, opacity: 0}).animate({opacity: 1}, config.switchTime, config.easing, function() {
                $(current).css({zIndex: 0});
                $(replace).css({zIndex: 1});
                callback();
              });
            }
          },
          xscroll: {
            init: function(instance, current) {
              $(instance).children().css({zIndex: 0, opacity: 0, left: 0});
              $(current).css({zIndex: 1, opacity: 1});
            },
            reset: function(instance) {
              $(helper).stop();
              $(instance).children().css({zIndex: '', opacity: '', left: ''});
            },
            animate: function(instance, current, replace, callback, action) {
              var dir = (action == 'next') ? true : (action == 'prev') ? false : ($(replace).index() - $(current).index() > 0) ? true : false;
              $(replace).css({zIndex: 1, opacity: 1});
              helper.value = 0;
              $(helper).animate({value: 1}, {
                duration: config.switchTime,
                easing: config.easing,
                step: dir ? function(now, fx) {
                  $(current).css({left: (100 * ( 0 - fx.pos)) + '%'});
                  $(replace).css({left: (100 * (+1 - fx.pos)) + '%'});
                } : function(now, fx) {
                  $(current).css({left: (100 * ( 0 + fx.pos)) + '%'});
                  $(replace).css({left: (100 * (-1 + fx.pos)) + '%'});
                },
                complete: function() {
                  $(current).css({zIndex: 0, opacity: 0, left: 0});
                  $(replace).css({zIndex: 1, opacity: 1, left: 0});
                  callback();
                }
              });
            }
          },
          yscroll: {
            init: function(instance, current) {
              $(instance).children().css({zIndex: 0, opacity: 0, top: 0});
              $(current).css({zIndex: 1, opacity: 1});
            },
            reset: function(instance) {
              $(helper).stop();
              $(instance).children().css({zIndex: '', opacity: '', top: ''});
            },
            animate: function(instance, current, replace, callback, action) {
              var dir = (action == 'next') ? true : (action == 'prev') ? false : ($(replace).index() - $(current).index() > 0) ? true : false;
              $(replace).css({zIndex: 1, opacity: 1});
              helper.value = 0;
              $(helper).animate({value: 1}, {
                duration: config.switchTime,
                easing: config.easing,
                step: dir ? function(now, fx) {
                  $(current).css({top: (100 * ( 0 - fx.pos)) + '%'});
                  $(replace).css({top: (100 * (+1 - fx.pos)) + '%'});
                } : function(now, fx) {
                  $(current).css({top: (100 * ( 0 + fx.pos)) + '%'});
                  $(replace).css({top: (100 * (-1 + fx.pos)) + '%'});
                },
                complete: function() {
                  $(current).css({zIndex: 0, opacity: 0, top: 0});
                  $(replace).css({zIndex: 1, opacity: 1, top: 0});
                  callback();
                }
              });
            }
          },
          showhide: {
            init: function(instance, current) {
              $(instance).children().css({zIndex: 0, opacity: 0, display: 'none'});
              $(current).css({zIndex: 1, opacity: 1, display: ''});
            },
            reset: function(instance) {
              $(instance).children().css({zIndex: '', opacity: '', display: ''});
            },
            animate: function(instance, current, replace, callback, action) {
              $(current).animate({opacity: 0}, Math.ceil(config.switchTime / 2), config.easing, function() {
                $(current).css({zIndex: 0, opacity: 0, display: 'none'});
                $(replace).css({zIndex: 1, opacity: 0, display: ''}).animate({opacity: 1}, Math.ceil(config.switchTime / 2), config.easing, function() {
                  callback();
                });
              });
            }
          }
        };

        // animation type
        var animation = config.animation in animations ? animations[config.animation] : animations['fade'];

        // initialize slideshow
        function init() {
          play = config.play;
          current = $(instance).children().get(config.index) || $(instance).children().get(0) || false;
          replace = inqueue = false;
          animation.init(instance, current);
          if ($.isFunction(config.callback)) {
            config.callback.call(instance, $(current).index(), null, 'init', false != inqueue);
          }
        }

        // reset slideshow
        function reset() {
          animation.reset(instance);
          current = replace = inqueue = false;
        }

        // animate slideshow
        function animate(index, action) {
          var slide = $(instance).children().get(index);
          if (slide) {
            if (replace) {
              if (config.queue && current != slide) {
                inqueue = [slide, action];
              }
            } else {
              if (timeout) {
                window.clearTimeout(timeout);
              }
              if (current == slide) {
                if (play) {
                  timeout = window.setTimeout(function() {
                    slideshow.once();
                  }, config.pauseTime);
                }
              } else {
                if ($.isFunction(config.callback)) {
                  config.callback.call(instance, $(slide).index(), false, action, false != inqueue);
                }
                replace = current;
                current = slide;
                animation.animate(instance, replace, current, function() {
                  replace = false;
                  if ($.isFunction(config.callback)) {
                    config.callback.call(instance, $(current).index(), true, action, false != inqueue);
                  }
                  if (inqueue) {
                    animate($(inqueue[0]).index(), inqueue[1]);
                    inqueue = false;
                  } else if (play && (config.continuous || $(current).index() < $(instance).children().length - 1)) {
                    timeout = setTimeout(function() {
                      slideshow.once();
                    }, config.pauseTime);
                  }
                }, action);
              }
            }
          }
        }

        // create instance by call
        if (!(slideshow instanceof Slideshow)) {
          return new Slideshow();
        }

        // override toString
        slideshow.toString = function toString() {
          return '[object Slideshow]';
        }

        // init
        slideshow.init = function() {
          reset();
          init();
          if (play) {
            slideshow.play(true);
          }
        },

        // reset
        slideshow.reset = function() {
          slideshow.stop();
          reset();
        },
        // show by index
        slideshow.show = function(index) {
          animate(index || 0, 'show');
        },

        // show previous
        slideshow.prev = function() {
          animate($(current).index() > 0 ? $(current).index() - 1 : $(instance).children().length - 1, 'prev');
        },

        // show next
        slideshow.next = function() {
          animate($(current).index() < $(instance).children().length - 1 ? $(current).index() + 1 : 0, 'next');
        },

        // once
        slideshow.once = function() {
          if (config.reverse) {
            slideshow.prev();
          } else {
            slideshow.next();
          }
        },

        // play
        slideshow.play = function(pause) {
          play = true;
          if (pause) {
            if (timeout) {
              window.clearTimeout(timeout);
            }
            timeout = window.setTimeout(function() {
              slideshow.play();
            }, config.pauseTime);
          } else {
            slideshow.once();
          }
        },

        // stop
        slideshow.stop = function() {
          play = false;
          if (timeout) {
            window.clearTimeout(timeout);
          }
        }
      }
      
      // create slideshow
      var slideshow = new Slideshow(this);

      // bind events
      var instance = this;
      $(instance)
        .on(config.prefix + '-init', function(event) {
        slideshow.init();
      }).on(config.prefix + '-show', function(event, index) {
        slideshow.show(index);
      }).on(config.prefix + '-prev', function(event) {
        slideshow.prev();
      }).on(config.prefix + '-next', function(event) {
        slideshow.next();
      }).on(config.prefix + '-once', function(event) {
        slideshow.once();
      }).on(config.prefix + '-play', function(event, pause) {
        slideshow.play(pause);
      }).on(config.prefix + '-stop', function(event) {
        slideshow.stop();
      }).on(config.prefix + '-kill', function(event) {
        $(instance)
          .off(config.prefix + '-init')
          .off(config.prefix + '-show')
          .off(config.prefix + '-prev')
          .off(config.prefix + '-next')
          .off(config.prefix + '-once')
          .off(config.prefix + '-play')
          .off(config.prefix + '-stop')
          .off(config.prefix + '-kill');
        slideshow.reset();
      }).trigger(config.prefix + '-init');

    });
  };
})(jQuery);
